// ============================================================
// ASTHA INTERNATIONAL — STORE INTERACTIONS
// Cart drawer · Add to cart · Buy now · Support chat
// ============================================================

(function() {
  'use strict';

  // ============================================================
  // CART DRAWER
  // ============================================================

  window.openCartDrawer = function() {
    var overlay = document.getElementById('cartOverlay');
    var drawer = document.getElementById('cart-drawer');
    if (overlay && drawer) {
      overlay.classList.add('active');
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = '-' + window.scrollY + 'px';
      window.loadCartContents();
    }
  };

  window.closeCartDrawer = function() {
    var overlay = document.getElementById('cartOverlay');
    var drawer = document.getElementById('cart-drawer');
    if (overlay && drawer) {
      overlay.classList.remove('active');
      drawer.classList.remove('open');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      var scrollY = parseInt(document.body.style.top || '0') * -1;
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
    }
  };

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') window.closeCartDrawer();
  });

  document.addEventListener('click', function(e) {
    if (e.target.id === 'cartOverlay') window.closeCartDrawer();
  });

  // ============================================================
  // LOAD CART CONTENTS
  // ============================================================

  window.loadCartContents = function() {
    var container = document.getElementById('cart-items-container');
    var countEl = document.getElementById('cartCount');
    var itemCountEl = document.getElementById('cartItemCount');
    var subtotalEl = document.getElementById('cart-subtotal');

    if (!container) return;

    fetch('/cart.js')
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to load cart');
        return response.json();
      })
      .then(function(cart) {
        var totalItems = 0;
        for (var i = 0; i < cart.items.length; i++) {
          totalItems += cart.items[i].quantity;
        }
        if (countEl) countEl.textContent = totalItems;
        if (itemCountEl) itemCountEl.textContent = '(' + totalItems + ')';

        if (cart.items.length === 0) {
          container.innerHTML = '<div class="cart-empty"><svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#c9a961" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg><p>Your cart is empty</p><a href="/collections/all" class="btn-primary">Start Shopping</a></div>';
          if (subtotalEl) subtotalEl.textContent = '$0.00';
          return;
        }

        var itemsHtml = '';
        var subtotal = 0;

        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          var price = parseFloat(item.price) / 100;
          var lineTotal = price * item.quantity;
          subtotal += lineTotal;
          var imageUrl = item.image || '';

          itemsHtml += '<div class="cart-item" data-key="' + item.key + '">';
          itemsHtml += '<img src="' + (imageUrl || 'https://via.placeholder.com/100x100?text=No+Image') + '" alt="' + item.title + '" loading="lazy">';
          itemsHtml += '<div class="cart-item-info">';
          itemsHtml += '<div class="cart-item-title">' + item.title + '</div>';
          itemsHtml += '<div class="cart-item-price">$' + price.toFixed(2) + '</div>';
          itemsHtml += '<div class="cart-item-qty">';
          itemsHtml += '<button onclick="window.updateCartQty(\'' + item.key + '\', ' + (item.quantity - 1) + ')">−</button>';
          itemsHtml += '<span class="qty-display">' + item.quantity + '</span>';
          itemsHtml += '<button onclick="window.updateCartQty(\'' + item.key + '\', ' + (item.quantity + 1) + ')">+</button>';
          itemsHtml += '<button class="cart-item-remove" onclick="window.removeCartItem(\'' + item.key + '\')">Remove</button>';
          itemsHtml += '</div></div></div>';
        }

        container.innerHTML = itemsHtml;
        if (subtotalEl) subtotalEl.textContent = '$' + subtotal.toFixed(2);
        if (countEl) countEl.textContent = totalItems;
        if (itemCountEl) itemCountEl.textContent = '(' + totalItems + ')';
      })
      .catch(function(error) {
        console.error('Error loading cart:', error);
        container.innerHTML = '<div class="cart-empty"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#cc0c39" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg><p>Error loading cart. Please refresh.</p></div>';
      });
  };

  // ============================================================
  // UPDATE CART QUANTITY
  // ============================================================

  window.updateCartQty = function(key, qty) {
    if (qty < 0) return;
    if (qty === 0) { window.removeCartItem(key); return; }

    var container = document.getElementById('cart-items-container');
    if (container) {
      container.innerHTML = '<div class="cart-loading"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1e3a2f" stroke-width="2"><path d="M12 2v4M12 22v-4M4 12H2M22 12h-2M19.07 4.93l-2.83 2.83M6.34 17.66l-2.83 2.83M17.66 6.34l2.83-2.83M6.34 6.34L4.93 4.93"/></svg><p>Updating...</p></div>';
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to update cart');
        return response.json();
      })
      .then(function(cart) {
        window.loadCartContents();
        var totalItems = 0;
        for (var i = 0; i < cart.items.length; i++) totalItems += cart.items[i].quantity;
        var countEl = document.getElementById('cartCount');
        if (countEl) countEl.textContent = totalItems;
      })
      .catch(function(error) {
        console.error('Error updating cart:', error);
        window.loadCartContents();
        window.showAsthaPopup('Something went wrong. Please try again.', 'error');
      });
  };

  // ============================================================
  // REMOVE FROM CART
  // ============================================================

  window.removeCartItem = function(key) {
    if (!confirm('Remove this item from your cart?')) return;

    var container = document.getElementById('cart-items-container');
    if (container) {
      container.innerHTML = '<div class="cart-loading"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#1e3a2f" stroke-width="2"><path d="M12 2v4M12 22v-4M4 12H2M22 12h-2M19.07 4.93l-2.83 2.83M6.34 17.66l-2.83 2.83M17.66 6.34l2.83-2.83M6.34 6.34L4.93 4.93"/></svg><p>Removing...</p></div>';
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to remove item');
        return response.json();
      })
      .then(function(cart) {
        window.loadCartContents();
        var totalItems = 0;
        for (var i = 0; i < cart.items.length; i++) totalItems += cart.items[i].quantity;
        var countEl = document.getElementById('cartCount');
        if (countEl) countEl.textContent = totalItems;
      })
      .catch(function(error) {
        console.error('Error removing item:', error);
        window.loadCartContents();
        window.showAsthaPopup('Something went wrong. Please try again.', 'error');
      });
  };

  // ============================================================
  // ADD TO CART NOTIFICATION (top-right popup)
  // ============================================================

  window.showAsthaPopup = function(message, type, productData) {
    var existing = document.querySelector('.astha-popup-overlay');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.className = 'astha-popup-overlay';
    overlay.style.cssText =
      'position:fixed;' +
      'top:0;left:0;' +
      'width:100%;height:100%;' +
      'z-index:999999;' +
      'pointer-events:none;';

    var html = '';

    if (type === 'success' && productData) {
      var imageUrl = productData.image || 'https://via.placeholder.com/60x60?text=No+Image';
      var price = productData.price || '0.00';
      var qty = productData.quantity || 1;
      var title = message || 'Product';

      html = `
        <div class="astha-popup" style="
          position:fixed;
          top:100px;
          right:20px;
          width:380px;
          max-width:92vw;
          background:#ffffff;
          border-radius:12px;
          box-shadow:0 20px 50px rgba(30,58,47,0.18);
          overflow:hidden;
          pointer-events:auto;
          animation:asthaSlideRight 0.35s ease;
          font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif;
          border:1px solid #e6ebe6;
          z-index:1000000;
        ">
          <div style="
            padding:12px 16px;
            display:flex;
            align-items:center;
            gap:10px;
            background:#faf7f0;
            border-bottom:1px solid #e6ebe6;
          ">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1e3a2f" stroke-width="2.5">
              <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
            <span style="font-size:15px;font-weight:700;color:#1e3a2f;">Added to your cart</span>
            <button onclick="this.closest('.astha-popup').remove();this.closest('.astha-popup-overlay').remove();" style="
              margin-left:auto;
              background:none;
              border:none;
              font-size:18px;
              cursor:pointer;
              color:#a89a82;
              padding:0 4px;
              line-height:1;
            ">✕</button>
          </div>

          <div style="padding:14px 16px;display:flex;gap:12px;align-items:center;">
            <img src="${imageUrl}" alt="${title}" style="
              width:60px;height:60px;object-fit:contain;border-radius:6px;
              background:#faf7f0;border:1px solid #e6ebe6;flex-shrink:0;
            " onerror="this.src='https://via.placeholder.com/60x60?text=No+Image'">
            <div style="flex:1;min-width:0;">
              <div style="
                font-size:13px;font-weight:600;color:#1e3a2f;
                display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;
                overflow:hidden;line-height:1.3;
              ">${title}</div>
              <div style="font-size:18px;font-weight:700;color:#1e3a2f;margin-top:2px;">$${price}</div>
              <div style="font-size:12px;color:#6b7a72;">Qty: ${qty}</div>
            </div>
          </div>

          <div style="
            padding:10px 16px 14px;display:flex;gap:8px;flex-wrap:wrap;
            border-top:1px solid #e6ebe6;background:#ffffff;
          ">
            <button onclick="this.closest('.astha-popup').remove();this.closest('.astha-popup-overlay').remove();" style="
              flex:1;min-width:70px;padding:9px 12px;
              border:1px solid #e6ebe6;border-radius:999px;
              font-size:12px;font-weight:700;cursor:pointer;
              background:#ffffff;color:#1e3a2f;letter-spacing:0.06em;text-transform:uppercase;
            ">Continue</button>
            <button onclick="this.closest('.astha-popup').remove();this.closest('.astha-popup-overlay').remove();window.openCartDrawer();" style="
              flex:1;min-width:70px;padding:9px 12px;
              border:1px solid #1e3a2f;border-radius:999px;
              font-size:12px;font-weight:700;cursor:pointer;
              background:#1e3a2f;color:#ffffff;letter-spacing:0.06em;text-transform:uppercase;
            ">View Cart</button>
            <button onclick="window.location.href='/checkout'" style="
              flex:1;min-width:70px;padding:9px 12px;
              border:1px solid #c9a961;border-radius:999px;
              font-size:12px;font-weight:700;cursor:pointer;
              background:#c9a961;color:#1e3a2f;letter-spacing:0.06em;text-transform:uppercase;
            ">Checkout</button>
          </div>
        </div>
      `;

      var style = document.createElement('style');
      style.textContent =
        '@keyframes asthaSlideRight {' +
        '  from { opacity: 0; transform: translateX(40px) scale(0.96); }' +
        '  to { opacity: 1; transform: translateX(0) scale(1); }' +
        '}';
      document.head.appendChild(style);
    } else {
      var bgColor = type === 'error' ? '#cc0c39' : '#1e3a2f';
      var icon = type === 'error' ? '✕' : '⟳';
      html = `
        <div style="
          position:fixed;top:100px;right:20px;
          background:${bgColor};color:#fff;
          padding:14px 24px;border-radius:999px;
          font-size:14px;font-weight:600;
          box-shadow:0 12px 30px rgba(30,58,47,0.25);
          pointer-events:auto;
          animation:asthaSlideRight 0.35s ease;
          font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Arial,sans-serif;
          z-index:1000000;
        ">${icon} ${message}</div>
      `;
    }

    overlay.innerHTML = html;
    document.body.appendChild(overlay);

    if (type === 'success') {
      setTimeout(function() {
        var popup = overlay.querySelector('.astha-popup');
        if (popup) {
          popup.style.opacity = '0';
          popup.style.transform = 'translateX(40px)';
          popup.style.transition = 'all 0.3s ease';
          setTimeout(function() {
            if (overlay.parentNode) overlay.remove();
          }, 300);
        }
      }, 5000);
    } else if (type !== 'loading') {
      setTimeout(function() {
        var popup = overlay.querySelector('.astha-popup');
        if (popup) {
          popup.style.opacity = '0';
          popup.style.transform = 'translateX(40px)';
          popup.style.transition = 'all 0.3s ease';
          setTimeout(function() {
            if (overlay.parentNode) overlay.remove();
          }, 300);
        }
      }, 3000);
    }
  };

  // ============================================================
  // ADD TO CART
  // ============================================================

  window.addToCart = function(variantId, quantity, productTitle, productImage, productPrice) {
    quantity = quantity || 1;
    productTitle = productTitle || 'Product';
    productImage = productImage || '';
    productPrice = productPrice || '0.00';

    var clickedButton = null;
    var allButtons = document.querySelectorAll('.btn-add, .add-cart, .amazon-add-to-cart, .related-item .add-cart, .slider-add-to-cart');
    for (var i = 0; i < allButtons.length; i++) {
      var btn = allButtons[i];
      if (btn.getAttribute('onclick') && btn.getAttribute('onclick').indexOf(String(variantId)) !== -1) {
        clickedButton = btn;
        btn.textContent = 'Adding...';
        btn.disabled = true;
        btn.style.opacity = '0.6';
        btn.style.cursor = 'not-allowed';
        break;
      }
    }

    window.showAsthaPopup('Adding to cart...', 'loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to add to cart');
        return response.json();
      })
      .then(function(item) {
        var title = item.title || productTitle;
        var price = (parseFloat(item.price) / 100).toFixed(2) || productPrice;
        var image = item.image || productImage;
        var qty = item.quantity || quantity;

        window.showAsthaPopup(title, 'success', {
          image: image,
          price: price,
          quantity: qty,
          variantId: variantId
        });

        fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            var totalItems = 0;
            for (var i = 0; i < cart.items.length; i++) totalItems += cart.items[i].quantity;
            var countEl = document.getElementById('cartCount');
            if (countEl) countEl.textContent = totalItems;
            var drawerEl = document.getElementById('cart-drawer');
            if (drawerEl && drawerEl.classList.contains('open')) window.loadCartContents();
          })
          .catch(function() {});

        if (clickedButton) {
          clickedButton.textContent = 'Add to Cart';
          clickedButton.disabled = false;
          clickedButton.style.opacity = '1';
          clickedButton.style.cursor = 'pointer';
        }
      })
      .catch(function(error) {
        console.error('Error adding to cart:', error);
        window.showAsthaPopup('Failed to add. Please try again.', 'error');
        if (clickedButton) {
          clickedButton.textContent = 'Add to Cart';
          clickedButton.disabled = false;
          clickedButton.style.opacity = '1';
          clickedButton.style.cursor = 'pointer';
        }
      });
  };

  // ============================================================
  // BUY NOW
  // ============================================================

  window.buyNow = function(variantId, quantity) {
    quantity = quantity || 1;

    var btn = document.querySelector('.btn-buy, .buy-now, .amazon-buy-now');
    if (btn) {
      btn.textContent = 'Processing...';
      btn.disabled = true;
      btn.style.opacity = '0.6';
    }

    window.showAsthaPopup('Processing your order...', 'loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to add to cart');
        return response.json();
      })
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function(error) {
        console.error('Error:', error);
        window.showAsthaPopup('Failed. Please try again.', 'error');
        if (btn) {
          btn.textContent = 'Buy Now';
          btn.disabled = false;
          btn.style.opacity = '1';
        }
      });
  };

  // ============================================================
  // SUPPORT CHAT
  // ============================================================

  window.toggleChat = function() {
    var chatWindow = document.getElementById('chatWindow');
    if (chatWindow) chatWindow.classList.toggle('open');
  };

  window.sendSupportMsg = function() {
    var input = document.getElementById('chatMsg');
    var messages = document.getElementById('chatMessages');
    if (!input || !messages || !input.value.trim()) return;

    var msg = input.value.trim();

    var userDiv = document.createElement('div');
    userDiv.className = 'message user';
    userDiv.innerHTML = '<div class="message-content">' + msg + '</div>';
    messages.appendChild(userDiv);

    input.value = '';
    messages.scrollTop = messages.scrollHeight;

    setTimeout(function() {
      var autoReply = '';
      var lowerMsg = msg.toLowerCase();

      if (lowerMsg.includes('return') || lowerMsg.includes('refund')) {
        autoReply = "We're happy to help with returns. Please email support@asthainternational.com and our team will respond within one business day.";
      } else if (lowerMsg.includes('shipping') || lowerMsg.includes('delivery')) {
        autoReply = "We offer free shipping on all USA orders. Standard delivery takes 3–5 business days.";
      } else if (lowerMsg.includes('order') || lowerMsg.includes('track')) {
        autoReply = "You can track your order any time using our Order Tracking page. Need extra help? Email support@asthainternational.com.";
      } else if (lowerMsg.includes('hours') || lowerMsg.includes('open')) {
        autoReply = "Our support team is available 24/7. Call us at +1 (856) 257-3752 or email support@asthainternational.com.";
      } else if (lowerMsg.includes('price') || lowerMsg.includes('cost') || lowerMsg.includes('wholesale')) {
        autoReply = "For retail pricing, browse the site. For wholesale or bulk orders, email support@asthainternational.com.";
      } else if (lowerMsg.includes('hello') || lowerMsg.includes('hi')) {
        autoReply = "Hello! Welcome to Astha International. How can we help you today?";
      } else if (lowerMsg.includes('thank')) {
        autoReply = "You're welcome. Happy to help — thank you for shopping with Astha International.";
      } else if (lowerMsg.includes('affiliate') || lowerMsg.includes('influencer') || lowerMsg.includes('collab')) {
        autoReply = "Interested in partnering with us? Our affiliate program pays 25% commission. Apply by emailing support@asthainternational.com with your social handles.";
      } else {
        autoReply = "Thank you for reaching out. Our team will respond shortly. For immediate assistance, email support@asthainternational.com.";
      }

      var supportDiv = document.createElement('div');
      supportDiv.className = 'message support';
      supportDiv.innerHTML = '<div class="message-content">' + autoReply + '</div>';
      messages.appendChild(supportDiv);
      messages.scrollTop = messages.scrollHeight;
    }, 800);
  };

  document.addEventListener('DOMContentLoaded', function() {
    var chatInput = document.getElementById('chatMsg');
    if (chatInput) {
      chatInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          window.sendSupportMsg();
        }
      });
    }
  });

  // ============================================================
  // INIT
  // ============================================================

  document.addEventListener('DOMContentLoaded', function() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var totalItems = 0;
        for (var i = 0; i < cart.items.length; i++) totalItems += cart.items[i].quantity;
        var countEl = document.getElementById('cartCount');
        if (countEl) countEl.textContent = totalItems;
      })
      .catch(function() {});
  });

  console.log('✅ Astha International store active');

})();